import { PriceAdjustedBy } from "@/features/my-order/features/order-history/features/final-copy/types";

export const calcConfirmedCondition = (condition: PriceAdjustedBy) => {
  if (!condition) return;

  const type = condition.by;
  const value = condition.value;

  if (type === "MARKUP") {
    const symbol = "C";
    const sign = value > 0 || value === 0 ? "+" : "";
    return `${symbol}${sign}${value}%`;
  }

  if (type === "DISCOUNT") {
    const discountValue = value * -1;
    const symbol = "R";
    const sign = discountValue === 0 ? "-" : discountValue > 0 ? "+" : "";
    return `${symbol}${sign}${discountValue}%`;
  }
};
